module.exports = __webpack_public_path__ + "static/img/logo.c4509b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = Z2Ou
// module chunks = 6